import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Default language
    fallbackLng: 'en',
    
    // Supported languages
    supportedLngs: ['en', 'ar'],
    
    // Resources (translations)
    resources: {
      en: {
        translation: enTranslations
      },
      ar: {
        translation: arTranslations
      }
    },
    
    // Detection options
    detection: {
      // Order of detection methods
      order: ['path', 'localStorage', 'navigator'],
      
      // Keys to lookup language from
      lookupLocalStorage: 'langChange',
      lookupFromPathIndex: 1, // Language is at index 1 in path (e.g., /en/about-us)
      
      // Cache user language
      caches: ['localStorage'],
    },
    
    // React options
    react: {
      useSuspense: false
    },
    
    // Interpolation options
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    // Debug mode (set to false in production)
    debug: false
  });

export default i18n;

